import { apiVersion, getUserUrl } from './config';

export async function getUserTime() {
  const config = {
    url: `${getUserUrl(apiVersion)}/time/heartbeat`,
    method: 'POST',
    headers: {},
  };

  try {
    const response = await fetch(config.url, {
      method: config.method,
      headers: config.headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (e) {
    console.log(e);
    throw { status: 408 };
  }
}
